import { useEventConfig } from '@/eventConfig/useEventConfig.ts';
import { translate } from '@/translation/translate.ts';
import { addReqiredMessage } from '@/components/slides/DataSummary/util/addRequiredMessage.ts';
import { EditDataField } from '@/components/slides/DataSummary/components/EditDataField.tsx';
import { useSummaryFormField } from '@/components/slides/DataSummary/components/useSummaryFormField.ts';
import { EditSaveButtons } from '@/components/slides/DataSummary/components/EditSaveButtons.tsx';
import { useForm } from '@/form/useForm.ts';

export const NameSummaryFormZA = () => {
  const { onStartEdit, onCancelEdit, onSave, editMode, isValid } = useSummaryFormField({ slideIds: ['name', 'saId'] });

  const { getFieldValue } = useForm();

  const { eventConfig } = useEventConfig();
  const s = eventConfig!.slides;

  const salutationField = addReqiredMessage({
    field: s.name.fields.find(({ name }) => name === 'salutation'),
    message: s.dataSummary.requiredMessage!,
  });
  const salutationLabel = translate(salutationField?.label);
  const salutationValue =
    translate(salutationField?.options?.find(({ value }) => value === getFieldValue('salutation'))?.label) ||
    getFieldValue('salutation');

  const firstNameField = addReqiredMessage({
    field: s.name.fields.find(({ name }) => name === 'firstname'),
    message: s.dataSummary.requiredMessage!,
  });
  const firstNameLabel = translate(firstNameField?.label);

  const lastNameField = addReqiredMessage({
    field: s.name.fields.find(({ name }) => name === 'lastname'),
    message: s.dataSummary.requiredMessage!,
  });
  const lastNameLabel = translate(lastNameField?.label);

  const zaIdField = addReqiredMessage({
    field: s.saId.fields.find(({ name }) => name === 'za_id'),
    message: s.dataSummary.requiredMessage!,
  });
  const zaIdLabel = translate(zaIdField?.label);

  const titleField = s.name.fields.find(({ name }) => name === 'title');
  const titleLabel = translate(titleField?.label);
  const titleValue =
    translate(titleField?.options?.find(({ value }) => value === getFieldValue('title'))?.label) ||
    getFieldValue('title');

  const motherTongueField = s.name.fields.find(({ name }) => name === 'motherTongue');
  const motherTongueLabel = translate(motherTongueField?.label);
  const motherTongueValue =
    translate(motherTongueField?.options?.find(({ value }) => value === getFieldValue('motherTongue'))?.label) ||
    getFieldValue('motherTongue');

  const ethnicityField = s.name.fields.find(({ name }) => name === 'ethnicity');
  const ethnicityLabel = translate(ethnicityField?.label);
  const ethnicityValue =
    translate(ethnicityField?.options?.find(({ value }) => value === getFieldValue('ethnicity'))?.label) ||
    getFieldValue('ethnicity');

  return (
    <div className="summary-card" data-cy={'summary-form-name'}>
      <h2>{translate(s.dataSummary.titles?.name)}</h2>
      <EditSaveButtons
        editMode={editMode}
        onSave={onSave}
        onStartEdit={onStartEdit}
        onCancelEdit={onCancelEdit}
        isValid={isValid}
      />

      <div className="data">
        <div className={'label'}>{salutationLabel}</div>
        <div className={'value'}>
          {!editMode && salutationValue}
          {editMode && <EditDataField slideId={'name'} field={salutationField!} />}
        </div>

        <div className={'label'}>{titleLabel}</div>
        <div className={'value'}>
          {!editMode && titleValue}
          {editMode && <EditDataField slideId={'name'} field={titleField!} />}
        </div>
        <div className={'label'}>{firstNameLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('firstname')}
          {editMode && <EditDataField slideId={'name'} field={firstNameField!} />}
        </div>
        <div className={'label'}>{lastNameLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('lastname')}
          {editMode && <EditDataField slideId={'name'} field={lastNameField!} />}
        </div>
        <div className={'label'}>{zaIdLabel}</div>
        <div className={'value'}>
          {getFieldValue('za_id')}
          <div style={{ display: 'none' }}>
            <EditDataField slideId={'saId'} field={zaIdField!} />
          </div>
        </div>
        <div className={'label'}>{motherTongueLabel}</div>
        <div className={'value'}>
          {!editMode && motherTongueValue}
          {editMode && <EditDataField field={motherTongueField!} slideId={'name'} />}
        </div>
        <div className={'label'}>{ethnicityLabel}</div>
        <div className={'value'}>
          {!editMode && ethnicityValue}
          {editMode && <EditDataField field={ethnicityField!} slideId={'name'} />}
        </div>
      </div>
    </div>
  );
};
